import { create } from 'zustand';
import MICRO_LOGO from '../assets/images/micro-logo.png';
import USER_AVATAR from '../assets/images/user-avatar.png';
export interface GlobalStore {
  portalHeaderHeight: number;
  websiteHeaderHeight: number;
  sidebarWidth: number;
  contentPadding?: number | { xs: number; sm: number; md: number; lg: number; xl: number };
  setupFooterHeight: number;
  showNavCollapseIcon: boolean;
  showMiniSidebar: boolean;
  showMainSidebar: boolean;
  fullScreenContent: boolean;
  setPortalHeaderHeight: (height: number) => void;
  setWebsiteHeaderHeight: (height: number) => void;
  setSidebarWidth: (width: number) => void;
  setContentPadding: (value: number | { xs: number; sm: number; md: number; lg: number; xl: number }) => void;
  setSetupFooterHeight: (value: number) => void;
  setShowNavCollapseIcon: (value: boolean) => void;
  setShowMiniSidebar: (value: boolean) => void;
  setShowMainSidebar: (value: boolean) => void;
  setFullScreenContent: (value: boolean) => void;
  // Header
  showHeader: boolean;
  title: string;
  microSystemTitle: string;
  microSystemLogo: string;
  userAvatar: string;
  userName: string;
  userRole: string;
  setShowHeader: (value: boolean) => void;
  setTitle: (value: string) => void;
  setMicroSystemTitle: (value: string) => void;
  setMicroSystemLogo: (value: string) => void;
  setUserAvatar: (value: string) => void;
  setUserName: (value: string) => void;
  setUserRole: (value: string) => void;
}

const initialState = {
  portalHeaderHeight: 120,
  websiteHeaderHeight: 80,
  sidebarWidth: 350,
  setupFooterHeight: 80,
  showNavCollapseIcon: true,
  showMiniSidebar: true,
  showMainSidebar: true,
  fullScreenContent: false,
  // Header
  showHeader: true,
  title: 'Innovation Ecosysttem',
  microSystemTitle: 'GEIC MICROSystem',
  microSystemLogo: MICRO_LOGO as unknown as string,
  userAvatar: USER_AVATAR as unknown as string,
  userName: 'Penny',
  userRole: 'Staff',
};

export const useGlobalStore = create<GlobalStore>()((set) => ({
  ...initialState,
  setPortalHeaderHeight: (newData) => set(() => ({ portalHeaderHeight: newData })),
  setWebsiteHeaderHeight: (newData) => set(() => ({ websiteHeaderHeight: newData })),
  setSidebarWidth: (newData) => set(() => ({ sidebarWidth: newData })),
  setContentPadding: (newData) => set(() => ({ contentPadding: newData })),
  setSetupFooterHeight: (newData) => set(() => ({ setupFooterHeight: newData })),
  setShowNavCollapseIcon: (newData) => set(() => ({ showNavCollapseIcon: newData })),
  setShowMiniSidebar: (newData) => set(() => ({ showMiniSidebar: newData })),
  setShowMainSidebar: (newData) => set(() => ({ showMainSidebar: newData, sidebarWidth: newData ? 350 : 90 })),
  setFullScreenContent: (newData) => set(() => ({ fullScreenContent: newData })),
  // Header
  setShowHeader: (newData) => set(() => ({ showHeader: newData })),
  setTitle: (newData) => set(() => ({ title: newData })),
  setMicroSystemTitle: (newData) => set(() => ({ microSystemTitle: newData })),
  setMicroSystemLogo: (newData) => set(() => ({ microSystemLogo: newData })),
  setUserAvatar: (newData) => set(() => ({ userAvatar: newData })),
  setUserName: (newData) => set(() => ({ userName: newData })),
  setUserRole: (newData) => set(() => ({ userRole: newData })),
}));
